export default {"src":"https://cdn.sa-tech.de/homeone/main/_next/static/media/whatsapp.faae45d8.svg","height":55,"width":55,"blurWidth":0,"blurHeight":0};